import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
export function ScarcityBar() {
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > 3 ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const claimed = Math.round((TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100);
  return <div className="rounded-2xl bg-alert-50 p-4 ring-1 ring-alert-200" data-id="element-50" data-mp="2b5fauj9uewwc">
      <div className="flex items-center justify-between gap-3 text-sm font-extrabold text-alert-700" data-id="element-51" data-mp="2g6mj0jfwdy3j">
        <span className="flex items-center gap-1.5" data-id="element-52" data-mp="227dcycleokda">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-53" data-mp="274ve3gt6lvaq" />
          Only {spotsLeft} spots left at the launch price
        </span>
        <span className="shrink-0 tabular-nums" data-id="element-54" data-mp="g09zt300mjv">{claimed}%</span>
      </div>
      <div className="mt-3 h-4 overflow-hidden rounded-full bg-alert-100" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={claimed} aria-label="Promotional spots claimed" data-id="element-55" data-mp="5e1u8hc5urwx">
        <div className="scarcity-stripes h-full rounded-full bg-alert-500 transition-[width] duration-300 ease-out" style={{
        width: `${claimed}%`
      }} data-id="element-56" data-mp="2zj70y5lp2nml" />
      </div>
      <p className="mt-2 text-xs leading-relaxed text-navy-900/70" data-id="element-57" data-mp="38ed7x7wpbbqp">
        Once these spots are gone, the $27 promotional price will no longer be available.
      </p>
    </div>;
}